import { render, staticRenderFns } from "./BaseEditableCard.vue?vue&type=template&id=79d0346c&scoped=true&"
import script from "./BaseEditableCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseEditableCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseEditableCard.vue?vue&type=style&index=0&id=79d0346c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d0346c",
  null
  
)

export default component.exports